import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {OrganisationId} from "common/types/organisation";
import {ProjectId} from "common/types/project";
import {MatterId} from "common/types/matter";

export type MatterUpdateContextAction = {
  type: MattersActionTypes["MATTER_UPDATE_CONTEXT"]["SUCCESS"];
  payload: {
    id: MatterId;
    context: string;
    client_context_id?: number | null;
    is_project_context_disabled?: boolean;
  };
};

export default function updateMatterContext(requestor) {
  return createReduxPromiseAction(
    ActionTypes.MATTER_UPDATE_CONTEXT,
    (
      organisationId: OrganisationId,
      projectId: ProjectId,
      matterId: MatterId,
      context: string,
      clientContextId?: number | null,
      isProjectContextDisabled?: boolean,
    ) => {
      const updates: {
        context: string;
        client_context_id?: number | null;
        is_project_context_disabled?: boolean;
      } = {
        context,
      };
      if (clientContextId !== undefined) {
        updates.client_context_id = clientContextId;
      }
      if (isProjectContextDisabled !== undefined) {
        updates.is_project_context_disabled = isProjectContextDisabled;
      }
      return requestor
        .patch(
          `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}`,
          updates,
          {
            withCredentials: true,
          },
        )
        .then(response => {
          return response.data;
        });
    },
  );
}
